export default __webpack_public_path__ + "static/media/mastercard.534144da.svg";